export const customColor = {
	bluePrimary: '#4F92EA'
};
